import {
  AfterViewInit,
  Component,
  Inject,
  OnDestroy,
  OnInit,
  Renderer2,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import {
  RestAuthentificationService,
  UserService,
} from 'src/app/core/rest-services/rest-services';
import { SessionService } from 'src/app/core/services/session.service';
import { CustomNavigationService } from 'src/app/core/services/custom-navigation.service';
import { ServicesService } from 'src/app/core/services/services.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthentificationService } from 'src/app/core/services/authentication.service';
import { Subscription } from 'rxjs';
import { WhiteLabel } from 'src/app/core/models/white-label';
import { UtilsService } from 'src/app/core/services/utils.service';
import { LANG } from 'src/app/core/utils/constant';
import { BreakpointObserver } from '@angular/cdk/layout';
import { environment } from 'src/environments/environment';
import { Language } from 'src/app/core/enums/enums';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.scss'],
})
export class LoginPageComponent implements OnInit, OnDestroy, AfterViewInit {
  currentLocation?: string;
  queryParam!: {
    key: string | null;
    mode: string | null;
    identifier: string | null;
    invitation_key: string | null;
    whiteLabelId: string | null;
  };
  $showloading!: Subscription;
  $hideloading!: Subscription;
  $WhiteLabelLoded!: Subscription;
  loadingEventsCount = 0;
  isWhiteLabel: boolean;
  whiteLabel: WhiteLabel;
  currentLanguage: string;
  L = Language;
  isVisibleSideInfo = true;
  xlReached = false;
  appVersion = '';

  constructor(
    public navigationService: CustomNavigationService,
    public authService: RestAuthentificationService,
    public authUtilService: AuthentificationService,
    public userService: UserService,
    public services: ServicesService,
    public sessionService: SessionService,
    public translateService: TranslateService,
    public route: Router,
    private route_: ActivatedRoute,
    private renderer: Renderer2,
    public utilService: UtilsService,
    private breakpointObserver: BreakpointObserver,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.currentLanguage = this.translateService.currentLang;
    this.route.routeReuseStrategy.shouldReuseRoute = () => false;
    this.isWhiteLabel = !!this.sessionService.getWhiteLabel();
    this.setHtmlClass(this.isWhiteLabel ? 'familycare' : 'kimbo');
    this.whiteLabel = this.sessionService.getWhiteLabel();
    if (
      this.route_.snapshot.queryParamMap &&
      ((this.route_.snapshot.queryParamMap.get('key') &&
        this.route_.snapshot.queryParamMap.get('identification')) ||
        this.route_.snapshot.queryParamMap.get('invitation_key') ||
        this.route_.snapshot.queryParamMap.get('id'))
    ) {
      this.queryParam = {
        key: this.route_.snapshot.queryParamMap.get('key'),
        mode: this.route_.snapshot.queryParamMap.get('mode'),
        identifier: this.route_.snapshot.queryParamMap.get('identification'),
        invitation_key:
          this.route_.snapshot.queryParamMap.get('invitation_key'),
        whiteLabelId: this.route_.snapshot.queryParamMap.get('id'),
      };

      if (this.queryParam?.whiteLabelId) {
        this.setHtmlClass('familycare');
        this.isWhiteLabel = true;
      }
    }
    breakpointObserver.observe('(min-width: 815px)').subscribe(state => {
      if (state.matches) {
        this.xlReached = true;
      } else {
        this.xlReached = false;
      }
    });
    this.services.sessionService.storeRequestToLogin();
    this.appVersion = environment.appVersion;
  }

  ngOnDestroy(): void {
    this.$showloading && this.$showloading.unsubscribe();
    this.$hideloading && this.$hideloading.unsubscribe();
    this.$WhiteLabelLoded && this.$WhiteLabelLoded.unsubscribe();
  }

  ngAfterViewInit(): void {
    window.scrollTo({
      top: 0,
      behavior: 'auto',
    });
    if (!this.xlReached) {
      this.disableScroll();
    }
  }

  setHtmlClass(className: string) {
    const htmlElement = this.renderer.selectRootElement('html', true);

    // Remove any previously added custom classes
    this.renderer.removeClass(htmlElement, 'familycare');
    this.renderer.removeClass(htmlElement, 'kimbo');

    // Add the new class
    this.renderer.addClass(htmlElement, className);
  }

  ngOnInit(): void {
    this.currentLocation = this.route.url;
    this.$showloading = this.services.eventService.subscribe(
      'show:loading',
      () => {
        this.loadingEventsCount += 1;
      }
    );
    this.$WhiteLabelLoded = this.services.eventService.subscribe(
      'whiteLabel:loaded',
      () => {
        this.isWhiteLabel = true;
        this.whiteLabel = this.sessionService.getWhiteLabel();
      }
    );

    this.$hideloading = this.services.eventService.subscribe(
      'hide:loading',
      () => {
        if (this.loadingEventsCount > 0) this.loadingEventsCount -= 1;
      }
    );
  }

  clickedOutside(): void {
    if (!this.xlReached) {
      this.isVisibleSideInfo && this.closeSideInfoPanel();
    }
  }

  enableScroll() {
    this.document.body.style.overflow = 'auto';
  }

  disableScroll() {
    this.document.body.style.overflow = 'hidden';
  }

  closeSideInfoPanel(): void {
    this.isVisibleSideInfo = false;
    this.enableScroll();
  }

  addUniqueIdToElements() {
    const elements = document.querySelectorAll('app-root *');
    let id = 0;
    for (let i = 0; i < elements.length; i++) {
      if (!elements[i].hasAttribute('id')) {
        elements[i].setAttribute('id', 'kimbo-unique-id-' + id);
        id++;
      }
    }
  }
}
